module.exports = __webpack_public_path__ + "static/img/ic_file_default.cdb953fe.png";